// src/components/HomeEmpowerSection.jsx - Ensure it has the correct class name for detection
import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomeEmpowerSection.css";

const HomeEmpowerSection = () => {
  const navigate = useNavigate();

  const goToEssentialOils = (imagePath) => {
    navigate("/products?category=essential-oils", {
      state: { bannerImage: imagePath }
    });
  };

  const goToFaceCare = (imagePath) => {
    navigate("/products?category=face-care", {
      state: { bannerImage: imagePath }
    });
  };

  return (
    <section className="empower-section-two">
      <div className="empower-wrapper-two">
        <p className="empower-subtitle-two">
          Empower Your Skin care
        </p>
        <h3 className="empower-heading-two">
          The harmony between powerful
          <span
            className="empower-img-two clickable"
            onClick={() => goToEssentialOils("/images/empowerscreen1st.avif")}
          >
            <img src="/images/empowerscreen1st.avif" alt="ingredient" />
          </span>
          high-performance ingredients
          <span
            className="empower-img-two clickable"
            onClick={() => goToEssentialOils("/images/empowerscreen2nd.avif")}
          >
            <img src="/images/empowerscreen2nd.avif" alt="skincare" />
          </span>
          and exceptionally simple
          <span
            className="empower-img-two clickable"
            onClick={() => goToFaceCare("/images/empowerscreen3rd.avif")}
          >
            <img src="/images/empowerscreen3rd.avif" alt="routine" />
          </span>
          skincare routines.
        </h3>
      </div>
    </section>
  );
};

export default HomeEmpowerSection;